<template>
  <div class="animated fadeIn">
    <div id="custom_backdrop"></div>
    <div class="row pageinfo">
      <b-col cols="4" lg="6">
        <!--Display Trash or Normal Table View-->
        <h2>Tickets Missing Hauls</h2>
      </b-col>
      <!--Gear Icon :data            :data   = "items_csv"      @click="openExcel()"          = "items"   ref="excel"   v-b-popover.hover.top="'Export to csv'"   @click="openExcel()"         :data   = "items" -->
      <b-col cols="8" lg="6">
        <b-btn class="pull-right ml5" v-b-popover.hover.top="'Activate/Deactivate bbl'" variant="info" @click="bbl()"><i class="fa fa-bullseye"></i></b-btn> 
       <!-- <b-btn class="pull-right ml5" v-b-popover.hover.top="'Select Datapoints'" variant="info" @click="openSelectColumns()"><i class="fa fa-cog"></i></b-btn>
        -->
        <download-excel
            ref="excel"
            :data   = "items_csv" 
            :fields = "json_fields"
            type    = "csv"
            :name   = "filename">   
            <span>
              <b-btn class="pull-right ml5" v-b-popover.hover.top="'Export to csv'" variant="info"><i class="fa fa-file-excel-o"></i></b-btn>           
            </span>
        </download-excel>
        <!--<b-btn class="pull-right ml5" v-b-popover.hover.top="'Create Folder'" variant="info" @click="openCreateFolder()"><i class="fa fa-folder"></i></b-btn>
        -->
        <!-- <b-btn v-if="role =='super_analyst' || role =='analyst' || role =='trucking_company_admin'" class="pull-right ml5" :pressed.sync="myToggle" v-b-popover.hover.top="'Activate/Deactivate hauls approved'" variant="info" @click="h_approved_change()"><i class="fa fa-toggle-on"></i></b-btn> -->
      </b-col> 
    </div>

    <!-- Filters block-->
    <div class="filters pb-2">
      <b-row>
        <b-col order="1" order-md="1" cols="8" sm="6" md="4" lg="2" class="my-1">
          <div class="input-group mb-3">
            <div class="input-group-prepend">
              <b-form-input v-model="filter" placeholder="Search" />
              <b-btn :disabled="!filter" @click="filter = ''">Clear</b-btn>
            </div>
          </div>
        </b-col>
      </b-row> 

      <b-row>
        <b-col v-if="role =='super_admin' || role =='trucking_company_admin'" class="my-1" title="Energy Companies" sm="6" md="3" lg="2">
          <b-dropdown class="custom_dropdown custom_dropdown_b" @show="activate_custom_backdrop" @hidden="deactivate_custom_backdrop"  :text="filters_save.energy_company_name" >
            <b-dropdown-item @click="ecFilter('All Energy Companies', 0)">All Energy Companies</b-dropdown-item>
            <b-dropdown-item v-for="energy_company_filter in energy_companies_filter" @click="ecFilter(energy_company_filter.company_name, energy_company_filter.id)">{{energy_company_filter.company_name}}</b-dropdown-item>
          </b-dropdown>
        </b-col>
        <b-col class="my-1 f9" title="Initial Date" sm="6" md="4" lg="3">
          <b-form-input id="haul_start_datetime" v-model="filter_by.initial_date" @change="iFilter" type="date" ></b-form-input>
        </b-col>
        <b-col class="my-1 lg-3 f10" title="End date" sm="6" md="4" lg="3">
          <b-form-input id="haul_end_datetime" v-model="filter_by.end_date" @change="eFilter" type="date"></b-form-input>
        </b-col>       
        <b-col class="my-1 lg-3 f11 " style=" padding-top: 3px; padding-bottom: 3px;" sm="6" md="4" lg="3">
          <b-button block style="height: 100%;" @click="clearFilters()">Clear</b-button>
        </b-col> 
      </b-row>
    </div>

    <!-- Main table block -->
    <div class="card">
      <div class="card-body p-0">
        <!-- Shows when loading data-->
        <b-row v-if="loadingData">
          <b-col cols="12" sm="12" md="12" lg="12">
            <p class="text-center"> <i class="fa fa-refresh fa-lg mt-4 fa-spin"></i><br> Loading data... </p>
          </b-col>
        </b-row>
        <div v-else class="table-responsive p-0 m-0">
          <b-table 
            class="animated fadeIn" 
            striped 
            bordered
            hover 
            show-empty 
            stacked="md" 
            :items="items" 
            :fields="fields" 
            :current-page="currentPage" 
            :per-page="perPage" 
            @filtered="onFiltered" 
            :filter="filter" 
            @row-clicked="rowClicked"
          >
            <template slot="bsw_unload" slot-scope="row" >
              <span >{{form1(row.item.bsw_unload)}}</span>
            </template>
            <template slot="oil_unload" slot-scope="row">
              <span >{{form(row.item.oil_unload)}}</span>
            </template>
            <template slot="volume_actual_unload" slot-scope="row">
              <span>{{form(row.item.volume_actual_unload)}}</span>
            </template>
          </b-table> 
        </div>
        <div class="table-controls">
          <b-row>
            <b-col lg="2" md="2" sm="12" class="my-1 pull-right">
              <div class="input-group mb-3">
                <div class="input-group-prepend"> </div>
                <b-select :options="pageOptions" v-model="perPage" />
              </div>
            </b-col>
            <b-col lg="10" md="10" sm="12" class="my-1">
              <b-pagination :total-rows="totalRows" :per-page="perPage" v-model="currentPage" class="mt-0 mb-3 pull-right" />
            </b-col>
          </b-row>
        </div>
        <!-- End User Interface controls-->
      </div>
    </div>
  </div>
</template>

<script>
  import Vue from 'vue'
  import VueSweetalert2 from 'vue-sweetalert2'
  import receipt_service from './receipt_service'
  import haul_service from '../hauls/haul_service'
  import moment from 'moment'
  import users_service from '../users/users_service'

  Vue.use(VueSweetalert2)
  
  const items = []
  export default {
    name: 'Receipt',
    created: function() {
      this.getAll()
    },
    data() {
      return {
        allSelected                 : false,
        tableValues                 : [],
        status                      :'unchecked',
        haul_ids                    : [],
        haul_iidds                  : [],
        haul_iiddss                 : [],
        selected                    : '',
        row: 0,
        loadingData: true,
        companyName: '',
        companyId: null,
        configTable: false,

        items: items,
        totalRows: items.length,
        v_items:null,
        fieldsSelected: 8,
        maxFieldsSelected: 24,
        tempFields: [],
        fields: [
        {
          key: 'energy_company_unload',
          label: 'Energy Company',
        },
        {
          key: 'way_bill',
          label: 'Way Bill',
          sortable: true,
        }, 
        {
          key: 'receipt_date',
          label: 'Receipt Date',
          sortable: true,
          formatter: (value) => { return moment(value).format("MMM DD, YYYY") }
        },
        {
          key: 'unload_location_unload',
          label: 'Unload',
          sortable: true,
        }, 
        {
          key: 'load_location_unload',
          label: 'Load',
          sortable: true,
        }, 
        {
          key: 'volume_actual_unload',
          label: 'Total Volume at Unload',
          sortable: true,
        },
        {
          key: 'bsw_unload',
          label: 'BS&W at Unload',
          sortable: true,
        },
        {
          key: 'oil_unload',
          label: 'Oil at Unload',
          sortable: false,
        },
        ],
        currentPage               : 1,
        perPage                   : 25,

        pageOptions               : [25, 50, 100],
        filter                    : null,
        modalInfo                 : {
          title: '',
          content: ''
        },
        modalEdit                 : {
          title: ''
        },
        selectedItems             : [
          'haul_id',
          'energy_company',          
          //'trucking_company',
          'unload_location',
          'ticket',
          'load_location',
          'volume_actual',
          'bsw',
          'oil_actual',
          'water_actual', 
          'energy_company_ul',  
          'unload_location_ul', 
          'volume_actual_ul',
          'bsw_ul',
          'oil_ul',
          'water_ul', 
        ],
				role                      :'',
				savebtn                   :true,
				energy_company_id         :null,
        unit                      :'',
        fromHaul                  :0,
        bbll                      :false,
        myToggle                  :false,
        filter_by:{"initial_date": moment().startOf('week').format('YYYY-MM-DD'), "end_date": moment().endOf('week').format('YYYY-MM-DD'), "truck_id": "","trucking_company_id":"", "users_id": "", "unload_location_id": "", "energy_companies_id": "", "load_location_id": "",
        "column":[

        ]},
        energy_companies_filter     : '',
        //folders                     : '',
        load_locations_filter       : '',
        unload_locations_filter     : '',
        drivers_filter              : '            ',
        trucks_filter               :'',
        trucking_companies_filter   :'',
        //fluid_types_filter          :'',
        filters_save              : {
          //folder_id               : 0,
          //folder                  : 'All Folders',
          energy_companies_id     : 0,
          energy_company_name     : 'All Energy Companies',
          users_id                : 0,
          driver_name             : 'All Drivers',
          truck_id                : 0,
          truck_name              : 'All Trucks',
          trucking_company_id     : 0,
          trucking_company_name   : 'All Trucking Companies',
          load_location_id        : 0,
          load_name               : 'All Loads',
          //fluid_type_id           : 0,
          //fluid_type_name         : 'All Fluid Types',
          unload_location_id      : 0,
          unload_name             : 'All UnLoads',
          initial_date            : '',
          end_date                : '',
          //flag_name               : 'All Flags',
          //sortby                  : 'haul_id',
          //sortdesc                : false
        },
        // export to csv
        filename : 'receipts_without_hauls'+moment().format('YYYYMMDDHHMM')+'.csv',        
        json_fields: {
          "receipt_id"                  :"receipt_id",
          "energy_company-unload"       :"energy_company_unload",
          "way_bill"                    :"way_bill",
          'receipt_date'                : 'receipt_date' ,
          "unload_location_unload"      :"unload_location_unload", 
          "load_location_unload"        :"load_location_unload",       
          "volume_actual_unload"        :"volume_actual_unload",  
          "bsw_unload"                  :"bsw_unload",      
          "oil_unload"                  :"oil_unload",        
       },
       items_csv: [],
      }
    },
    computed: {
      sortOptions() {
        // Create an options list from our fields
        return this.fields
          .filter(f => f.sortable)
          .map(f => {
            return {
              text: f.label,
              value: f.key
            }
          })

      }
    },
    methods: {
      selectAllHauls() {
        if (!this.allSelected) {
          this.toggleAllSelected();
        }
      },
      unselectAllHauls() {
        if (this.haul_ids.length>0 ) {
          //if (!this.h_approved) {
              this.haul_ids = []
          //} else {
              let tmp1 = this.tableValues.map(item => {
                   return item.haul_id})
              let tmp = this.haul_ids
              let tmp2 = this.array_diff(tmp, tmp1) 
              this.haul_ids = tmp2
          //}
        }
      },
      toggleAllSelected() {
        this.allSelected = !this.allSelected
        if (this.allSelected) {
          //if (!this.h_approved) {
           // this.haul_ids = []
            //this.haul_ids = this.tableValues.map(item => {
             //      return item.haul_id})
         // } else {
            let tmp = this.tableValues.map(item => {
                   return item.haul_id})
            let tmp1 = this.haul_ids
            tmp1.push.apply(tmp1,tmp)
            this.haul_ids = [...new Set(tmp1)]
          //}
        }
        else {
          //if (!this.h_approved) {
            //  this.haul_ids = []
          //} else {
              let tmp1 = this.tableValues.map(item => {
                   return item.haul_id})
              let tmp = this.haul_ids
              let tmp2 = this.array_diff(tmp, tmp1) 
              this.haul_ids = tmp2
          //}
        }
      },
      array_diff(tmp, tmp1) {
	      return tmp.filter(elemento => tmp1.indexOf(elemento) == -1)
      }, 

      checkedField(row) {
        if (this.haul_ids.includes(row.item.haul_id) ) {
          let index = this.haul_ids.indexOf(row.item.haul_id);
           if (index > -1) {
             this.haul_ids.splice(index, 1);
           }
        }else{
          this.haul_ids.push(row.item.haul_id)

        }
      },
      activate_custom_backdrop() {
        this.$root.$el.classList.add("custom_backdrop_behavior");
      },
      deactivate_custom_backdrop() {
        this.$root.$el.classList.remove("custom_backdrop_behavior");
      },
      openSelectColumns() {
        this.tempFields = [...this.fields]
        this.configTable = true
      },
      saveSelectedColumns() {
        this.fields = [...this.tempFields]
        this.configTable = false
      },
      shouldBeDisabled(option) {
        return (this.fieldsSelected >= this.maxFieldsSelected) && this.tempFields.map(o => o.key).indexOf(option) == -1
      },
      actionField(option, label, position) {
        var fieldsLength = this.tempFields.length
        var fieldIsActive = false
        for (var i = 0; i <= fieldsLength; i++) {
          fieldIsActive = true
          try {
            if (this.tempFields[i].key === option || this.tempFields[i] === option) {
              this.tempFields.splice(i, 1)
              fieldIsActive = false
              break
            }
          } catch (err) {

            if (option=='haul_start_date' || option=='haul_end_date') {
              option = {
                key: option,
                label: label,
                sortable: true,
                formatter: (value) => { return moment(value).format("MMM DD, YYYY") }
              }
            } else if (option=='oil_actual' || option=='volume_actual' || option=='water_actual') {
                      option = {
                        key: option,
                        label: label,
                        sortable: true,
                        formatter: (value) =>  { if (this.bbll==true){
                                    value = Number(value*6.289814).toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2})+' bbl'
                                  } else {
                                    value = Number(value).toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2})+' m³'
                                  }; return value }
                      }
            } else {
                option = {
                  key: option,
                  label: label,
                  sortable: true
                }
            }
            this.tempFields.splice(position, 0, option)
          }
        }
        this.fieldsSelected = this.tempFields.length
      },
      onFiltered(filteredItems) {
        this.totalRows = filteredItems.length
        this.currentPage = 1
      },
      getAll() {
        this.items = []
        //this.v_items = []
        receipt_service.get_receipts_wo_hauls(this.filter_by)
          .then(data => {
            if (data.status == 'success') {
              this.items      = data.hauls    //.filter(o => o.status_id == (this.trash ? 2 : 1))
              this.items_csv   = this.items 
              this.getAll1()
            }
            else {
              this.$swal(data.status, data.message, data.status)
              this.loadingData = false
              return
            }
            this.loadingData = false
          })
          .catch(error => {
            Vue.swal('Error', 'Server not response. ' + error, 'error')
            this.loadingData = false
          })
      },
      getAll1() {

        haul_service.getAll1()
          .then(data => {
            if (data.status == 'success') {
              
              this.energy_companies_filter  = data.energy_companies_filter
              //this.folders                  = data.folders
              this.drivers_filter           = data.drivers_filter
              this.load_locations_filter    = data.load_locations_filter
              this.unload_locations_filter  = data.unload_locations_filter
              this.trucks_filter            = data.trucks_filter
              //this.truck_types_filter       = data.truck_types_filter
              this.trucking_companies_filter = data.trucking_companies_filter
              //this.fluid_types_filter       = data.fluid_types_filter 

              this.bbll       = data.bbl
              this.role       = data.role
              if (this.role=='operations_manager') {
         this.fields=[
        {
          key: 'way_bill',
          label: 'Way Bill',
          sortable: true,
        }, 
        {
          key: 'receipt_date',
          label: 'Receipt Date',
          sortable: true,
          formatter: (value) => { return moment(value).format("MMM DD, YYYY") }
        },
        {
          key: 'unload_location_unload',
          label: 'Unload',
          sortable: true,
        }, 
        {
          key: 'load_location_unload',
          label: 'Load',
          sortable: true,
        }, 
        {
          key: 'volume_actual_unload',
          label: 'Total Volume at Unload',
          sortable: true,
        },
        {
          key: 'bsw_unload',
          label: 'BS&W at Unload',
          sortable: true,
        },
        {
          key: 'oil_unload',
          label: 'Oil at Unload',
          sortable: false,
        }
        ]               
              }

            }
            else {

              this.$swal(data.status, data.message, data.status)
              this.loadingData = false
              return
            }
            this.loadingData = false
          })
          .catch(error => {
            Vue.swal('Error', 'Server not response. ' + error, 'error')
            this.loadingData = false
          })
      },
      reformat(value) {
        if (value.indexOf('%')!= -1) {
            return Number(parseFloat(value.replace(" %", "")).toFixed(2)).toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2})+" %"
        } else if (value.indexOf('km')!= -1) {
            return Number(parseFloat(value.replace(" km", "")).toFixed(2)).toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2})+" km"
        } else {
            return Number(parseFloat(value).toFixed(2)).toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2})
        }
      },
      ecFilter(ec_filter,id) {
        this.filter_by['energy_companies_id'] = id

        if (id==0) {
          this.filter_by['energy_companies_id'] = ''
        }
        this.filters_save.energy_company_name =  ec_filter
        this.filters_save.energy_companies_id = id
        this.getAll()
        //this.saveFilters()
        this.loadingData = true

      },
      dFilter(d_filter,id) {
        this.filter_by['users_id'] = id
        if (id==0) {
          this.filter_by['users_id'] = ''
        }
        this.filters_save.driver_name =  d_filter
        this.filters_save.users_id = id
        this.getAll()
        //this.saveFilters()
        this.loadingData = true
      },
      tcFilter(tc_filter,id) {
        this.filter_by['trucking_company_id'] = id
        if (id==0) {
          this.filter_by['trucking_company_id'] = ''
        }
        this.filters_save.trucking_company_name =  tc_filter
        this.filters_save.trucking_company_id = id
        this.getAll()
        //this.saveFilters()
        this.loadingData = true
      },
      lFilter(l_filter,id) {
        this.filter_by['load_location_id'] = id
        if (id==0) {
          this.filter_by['load_location_id'] = ''
        }
        this.filters_save.load_name =  l_filter
        this.filters_save.load_location_id = id
        this.getAll()
        //this.saveFilters()
        this.loadingData = true
      },
      uFilter(u_filter,id) {
        this.filter_by['unload_location_id'] = id
        if (id==0) {
          this.filter_by['unload_location_id'] = ''
        }
        this.filters_save.unload_name =  u_filter
        this.filters_save.unload_location_id = id
        this.getAll()
        //this.saveFilters()
        this.loadingData = true
      },
      iFilter(a) {
        if (this.filter_by['end_date']=='' || !this.filter_by['end_date']) {
          this.filter_by['end_date'] = ''
          this.filters_save.end_date = ''
        }
        this.filter_by.initial_date = a
        this.filters_save.initial_date = this.filter_by.initial_date
        this.getAll()
        //this.saveFilters()
        this.loadingData = true
      },
      eFilter(a) {
        if (this.filter_by['initial_date'] =='' || !this.filter_by['initial_date']) {
          this.filter_by['initial_date'] = ''
          this.filters_save.initial_date = ''
        }
        this.filter_by.end_date = a
        this.filters_save.end_date = this.filter_by.end_date
        this.getAll()
        //this.saveFilters()
        this.loadingData = true
      },
      tFilter(t_filter,id) {
        this.filter_by['truck_id'] = id
        if (id==0) {
          this.filter_by['truck_id'] = ''
        }
        this.filters_save.truck_name =  t_filter
        this.filters_save.truck_id = id
        this.getAll()
        //this.saveFilters()
        this.loadingData = true
      },
      clearFilters() {
        this.filter_by = {"initial_date": moment().startOf('week').format('YYYY-MM-DD'), 
        "end_date": moment().endOf('week').format('YYYY-MM-DD'), 
        "truck_id": "",
        "trucking_company_id":"", 
        "users_id": "", 
        "unload_location_id": "", 
        "energy_companies_id": "", 
        "load_location_id": "", 
        "column":[
          'haul_id',
          'energy_company',          
          'trucking_company',
          'unload_location',
          'ticket',
          'load_location',
          'volume_actual',
          'bsw',
          'oil_actual',
          'water_actual', 
          'energy_company_ul',  
          'unload_location_ul', 
          'volume_actual_ul',
          'bsw_ul',
          'oil_ul',
          'water_ul', 
        ]}
        this.filters_save = {
          energy_companies_id   : 0,
          energy_company_name   : 'All Energy Companies',
          users_id              : 0,
          driver_name           : 'All Drivers',
          trucking_company_id   : 0,
          truck_id              : 0,
          truck_name            : 'All Trucks',
          trucking_company_name : 'All Trucking Companies',
          load_location_id      : 0,
          load_name             : 'All Loads',
          unload_location_id    : 0,
          unload_name           : 'All UnLoads',
          initial_date          : '', // moment().startOf('month').format('YYYY-MM-DD'),
          end_date              : '', //moment().endOf('month').format('YYYY-MM-DD'),
          flag_name             : 'All Flags',
          //sortby                : 'truck_ticket',
          //sortdesc              : false
        }
        //this.FromDash='NoWaittimes'
        this.getAll()
        //this.saveFilters()
        this.loadingData = true
      },
      rowClicked(row, index, e) {
        console.log('click')
      },
      bbl() {
        users_service.bbl()
          .then((data) => {
            Vue.swal(data[0], data[1], data[0])
              .then((result) => {
                if (data[0] == 'success') {
                  this.loadingData = true
                      this.getAll()
                }
              })
          })
      },    
      form(value) {
        if (value!=='--') {
          if (this.bbll==true){
              value = Number(value*6.289814).toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2})+' bbl'
          } else {
              value = Number(value).toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2})+' m³'
          }; return value
      } else {
         return value
      }
      },
      form1(value) {
        if (value!=='--') {
            return Number(value).toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2})+' %'
        } else {
            return value
        }
      },
  }
}
</script>

<style lang="scss" scoped>
  .show-details-cell{
    font-weight: 500;
    cursor: pointer;
  }
  .table-controls{
    padding: 14px 16px 0 16px;
  }
  /deep/ .table{
    margin: 0;
    td{
      white-space: nowrap;
      vertical-align: middle;
    }
    th{
      white-space: nowrap;
      vertical-align: middle;
    }
    td> div{
      line-height: 1;
    }
    .b-table-details> td {
      background-color: #FFFDF0;
    }
    .b-table-details h6{
      padding: 0;
      margin: 0;
      font-size: 0.8rem;
      line-height: 16px;
      margin-bottom: 8px;
      color: #676973;
    }
    .b-table-details p{
      font-size: 16px;
      color: #3A3E4D;
      padding: 0;
      margin: 0;
      line-height: 18px;
      margin-bottom: 16px;
    }
    .details-container{
      position: relative;
      white-space: normal; 
      display: flex; 
      flex-direction: row;
      flex-wrap: nowrap; 
      justify-content: flex-start;
      .item{
        padding-left: 10px;
        padding-right: 10px;
      }
      .item.location{
        width: 180px;
      }
      .item.ticket{
        width: 130px;
      }
      .item.date{
        width: 180px;
      }
      .item.volume{
        min-width: 100px;
      }
      &::after{
        content: '';
        position: absolute;
        top: 17px;
        left: 0;
        width: 20px;
        height: 100%;
        border-top: 1px solid #bcbcbc;
      }
      &::before{
        content: '';
        position: absolute;
        top: 17px;
        left: 0;
        width: 2px;
        height: 100%;
        border-left: 1px solid #bcbcbc;
      }
    }
    .details-container:last-child::before{
      display: none;
    }
  }
  /deep/ .btn-secondary{
    background: #ffffff;
  }
  /deep/ .custom-control {
    margin: 0;
    padding-left: 1rem;
  }
  /deep/ .select_column{width: 2%}
  /deep/ .bulk-action-controls{
    .dropdown{
      display: block;
      width: 100%;
    }
    .dropdown-toggle{
      display: block;
      width: 100%;
      text-align: left;
    }
    .dropdown-toggle::after {
      position: absolute;
      right: 15px;
      top: 50%;
      margin-top: -2px;
    }
    .close-controls{
      font-size: 18px; 
      font-weight: bold;
      height: 35px; 
      line-height: 14px;
      cursor: pointer;
      padding: 8px;
    }
    .btn-secondary{
      border-color: #cacaca;
    }
    .btn-select{
      height: 35px;
      margin-bottom: auto;
      margin-top: auto;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/receipt/receipt.vue